import { render, staticRenderFns } from "./BlockEditor.vue?vue&type=template&id=d08b55e8&scoped=true"
import script from "./BlockEditor.vue?vue&type=script&lang=js"
export * from "./BlockEditor.vue?vue&type=script&lang=js"
import style0 from "./BlockEditor.vue?vue&type=style&index=0&id=d08b55e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08b55e8",
  null
  
)

export default component.exports